
.button {
  box-sizing: border-box;
  border: none;
  padding: 6px 15px;
  font-family: var(--sbb-font-roman);
  font-size: 15px;
  line-height: 23px;
  height: 36px;
  max-width: 400px;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;

  > * {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.icon {
      flex-grow: 0;
    }
  }

  &.iconButton {
    min-width: initial;
    width: 36px;
    padding: 0;

    &.link {
      width: initial;
    }
  }

  &:hover:not(:disabled) {
    cursor: pointer;
  }

  &.primary {
    background-color: var(--sbb-color-red);
    color: var(--sbb-color-white);

    &:hover {
      background-color: var(--sbb-color-red125);
    }

    &:disabled {
      opacity: 0.5;
    }
  }

  &.secondary {
    background-color: var(--sbb-color-silver);
    color: var(--sbb-color-iron);

    &:hover {
      background-color: var(--sbb-color-platinum);
    }

    &:disabled {
      opacity: 0.4;
    }
  }

  &.ghost {
    background-color: rgba(0, 0, 0, 0);
    color: var(--sbb-color-granite);
    border: 1px solid var(--sbb-color-storm);

    &:hover {
      border-color: var(--sbb-color-iron);
    }

    &:disabled {
      opacity: 0.4;
    }
  }

  &.primaryAlt {
    background-color: var(--sbb-color-granite);
    color: var(--sbb-color-white);

    &:hover {
      background-color: var(--sbb-color-iron);
    }

    &:disabled {
      opacity: 0.4;
    }
  }

  &.link {
    display: inline-flex;
    background-color: initial;
    padding: initial;
    height: 23px;
    color: var(--sbb-color-black);
    max-width: initial;
    min-width: initial;
    line-height: 23px;

    .icon {
      margin: -7px 0;
    }

    &:hover {
      color: var(--sbb-color-red125);
    }
  }
}
